import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  Logout = '[Logout] Action',
  UserRequested = '[Request User] Action',
  UserRequestedAndEstablecimientos = '[Request User And Establecimientos] Action',
  UserEstablecimientosRequested = '[Request User Establecimientos] Action',
  UserLoaded = '[Load User] Auth API',
  UserEstablecimientosLoaded = '[Load User Establecimientos] Auth API',
  UserEstablecimientoSelectedRequested = '[User Establecimiento Selected Requested] Action',
  UserEstablecimientosSelectedLoaded = '[User Establecimientos Selected Loaded] Action',
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;
  constructor(public payload: { token: string }) {}
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
}

export class UserRequested implements Action {
  readonly type = AuthActionTypes.UserRequested;
}

export class UserRequestedAndEstablecimientos implements Action {
  readonly type = AuthActionTypes.UserRequestedAndEstablecimientos;
}

export class UserEstablecimientosRequested implements Action {
  readonly type = AuthActionTypes.UserEstablecimientosRequested;
}

export class UserLoaded implements Action {
  readonly type = AuthActionTypes.UserLoaded;
  constructor(public payload: { user: any }) {}
}

export class UserEstablecimientosLoaded implements Action {
  readonly type = AuthActionTypes.UserEstablecimientosLoaded;
  constructor(public payload: { establecimientos: any }) {}
}
export class UserEstablecimientoSelectedRequested implements Action {
  readonly type = AuthActionTypes.UserEstablecimientoSelectedRequested;
  constructor(public payload: { id: number }) {}
}

export class UserEstablecimientoSelectedLoaded implements Action {
  readonly type = AuthActionTypes.UserEstablecimientosSelectedLoaded;
  constructor(public payload: { establecimiento: any }) {}
}

export type AuthActions =
  | Login
  | Logout
  | UserRequested
  | UserRequestedAndEstablecimientos
  | UserEstablecimientosRequested
  | UserEstablecimientosLoaded
  | UserLoaded
  | UserEstablecimientoSelectedRequested
  | UserEstablecimientoSelectedLoaded;
